import { createSlice } from "@reduxjs/toolkit";
import { CommonTableState, updateTableState } from "./general/commonTableSliceFeatures";

type AccountantState = CommonTableState;

const initialState: AccountantState = {
    tableState: {
        resetIndicator: 0,
        sorting: [{ id: "licence.company.name", desc: false }],
        columnPinning: {
            right: ["mrt-row-actions"],
        },
        columnVisibility: {
            dataBox: false,
            created: false,
            creator: false,
        },
        columnOrder: [
            "licence.company.id",
            "user.id",
            "user.person.email",
            "user.person.phone",
            "user.person.dataBox",
            "softwareName",
            "licenceAdmin",
            "valid",
            "creator",
            "created",
            "mrt-row-actions",
        ],
        density: "compact",
    },
};

export const accountantSlice = createSlice({
    name: "accountant",
    initialState: initialState,
    reducers: {
        updateAccountantTableState: (state, payload) => updateTableState(state, payload, initialState.tableState),
    },
});

// Action creators are generated for each case reducer function
export const { updateAccountantTableState } = accountantSlice.actions;

export default accountantSlice.reducer;
